import { render, staticRenderFns } from "./teachersStatisticalReport.vue?vue&type=template&id=5a67aa83&"
import script from "./teachersStatisticalReport.vue?vue&type=script&lang=js&"
export * from "./teachersStatisticalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports